const mapaInit = () => {

    const selectorDiv = document.querySelector('#mapa');

    if ( selectorDiv ) {
        const selector = "div.cloudy-map-container";
        const modo = selectorDiv.dataset.modo;
        const api_key = selectorDiv.dataset.key;
        const id = selectorDiv.dataset.id;
        const tipoPlano = selectorDiv.dataset.tipo;
        const emprendimiento = selectorDiv.dataset.emprendimiento;
        let puedeVolver = false;
        const GOOGLE_MAPS_API_KEY = api_key;
        const GOOGLE_MAP_ID = id;
        const GOOGLE_MAPS_API_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=beta&map_ids=${GOOGLE_MAP_ID}&callback=cloudyScriptLoaded&loading=async`;
        
        mapApp.setup({
            selector, 
            modo,
            puedeVolver,
            tipoPlano,
            emprendimiento,
            GOOGLE_MAPS_API_URL, 
            GOOGLE_MAP_ID, 
            GOOGLE_MAPS_API_KEY
        });
    }
}

export {mapaInit};
